var _g, _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFingerDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_816_13335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.75 6.75H7.83333V12.5833H5.75V6.75ZM14.5 6.75H8.66667V12.9179L9.93417 14.8192L10.2863 17.2846C10.3155 17.4828 10.4148 17.664 10.5661 17.7952C10.7175 17.9265 10.9109 17.9991 11.1112 18H11.1667C11.4981 17.9997 11.8158 17.8679 12.0502 17.6335C12.2845 17.3992 12.4163 17.0814 12.4167 16.75V14.25H15.75C16.1919 14.2494 16.6155 14.0737 16.9279 13.7612C17.2403 13.4488 17.4161 13.0252 17.4167 12.5833V9.66667C17.4158 8.89339 17.1082 8.15204 16.5614 7.60525C16.0146 7.05846 15.2733 6.75088 14.5 6.75Z",
    fill: "#5A6078"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.49922,
    y: 1.49922,
    width: 19.0016,
    height: 19.0016,
    rx: 9.50078,
    stroke: "#5A6078",
    strokeWidth: 1.00156
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_816_13335"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(5 6)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFingerDown);
export default __webpack_public_path__ + "static/media/fingerDown.29574d59e328c15d36720df403a26bce.svg";
export { ForwardRef as ReactComponent };